'use client'

import { styled } from 'styled-components'

export const Wrapper = styled.section`
    width: min(100% - 32px, 1080px);
    height : calc(100dvh - 220px);
    margin : 120px auto 0;
`